module.exports = __webpack_public_path__ + "img/791.23bb75a0.png";